<template>
    <div class="news-table admin-table-page">
        <div>
            <div class="table-tools">
                <el-button type="primary" @click="onOpenForm">添加投放信息</el-button>
            </div>
            <el-table :data="tableData" class="table-area" v-loading="tableLoading"
                      element-loading-text="拼命查询中, 请稍候"
                      element-loading-spinner="el-icon-loading"
                      style="width: 100%">
                <el-table-column label="投放图片" :min-width="80">
                    <template slot-scope="scope">
                        <div class="news-table-imgs">
                            <span class="img-item" >
                                 <img :src="getImgUrl(scope.row.content)"/>
                            </span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="投放文案" :min-width="150" prop="name" :show-overflow-tooltip="true"/>
                <el-table-column label="投放项目" :min-width="150" prop="projectIds" :formatter="formatterProject" :show-overflow-tooltip="true"/>
                <el-table-column label="投放时间" :min-width="120" prop="launchTime" :show-overflow-tooltip="true"/>
                <el-table-column label="下架时间" :min-width="120" prop="withdrawTime" :show-overflow-tooltip="true"/>
                <el-table-column label="状态" :min-width="100" prop="status" :formatter="formatterStatus" :show-overflow-tooltip="true"/>
                <el-table-column label="操作" min-width="120">
                    <template slot-scope="scope">
                        <a class="c-main-color" v-if="scope.row.status === news_status.normal" @click="onWithdraw(scope.row)">下架</a>
                        <span class="c-gray btns" v-if="scope.row.status === news_status.withdraw">已下架</span>
                        <span  v-if="scope.row.status === news_status.pending">
                            <a class="c-main-color" @click="onLaunchNews(scope.row)">上架</a>
                            <a class="c-main-color" @click="onEdit(scope.row)">编辑</a>
                        </span>
                        <a class="c-main-color" @click="onView(scope.row)" v-else>查看</a>
                        <a class="c-main-color" @click="onDel(scope.row)">删除</a>
                    </template>
                </el-table-column>
            </el-table>
            <div class="no-data" v-show="noData">
                <noResult v-if="noData">
                    <div class="title">暂无数据</div>
                </noResult>
            </div>
        </div>
        <news-form v-model="formVisible" @submit="onFormSubmit" :data="currentRow" :edit="edit"></news-form>
    </div>
</template>
<script>
    import mix from '@/mixins/table-mixin.js'
    import noResult from '@/views/components/noResult'
    import newsService from '../../../request/service/news-service'
    import  newsForm from './news-form-dialog'
    import {news_status, news_status_names} from '@/const.js';
    export default {
        mixins: [mix],
        components: {
            noResult,newsForm
        },
        data() {
            return {
                news_status,
                tableLoading: false,
                formVisible: false,
                noData: false,
                tableData: [],
                columnInfo: [],
                currentRow: {},
                edit: true,
            }
        },
        computed: {
        },
        created() {
            this.init();
        },
        methods: {
            init() {
                this.getData();
            },
            getData(){
                this.tableLoading = true;
                newsService.getNews().then(({list}) => {
                    this.tableData = list;
                    this.noData = list.length === 0;
                }).finally(() => {
                    this.tableLoading = false;
                });
            },
            getImgUrl(content){
                if(content && content.indexOf(",") > -1){
                    return content.split(',')[0];
                }else{
                    return content;
                }
            },
            formatterProject({projectItems}) {
                let data = projectItems.map((item) => {
                    return item.name
                });
                return data.join(',');
            },
            formatterStatus({status}){
                return news_status_names[status];
            },
            handleView(index, row) {
                this.projectId = row.id;
                this.projectName = row.name;
                this.formVisible = true;
            },
            onSubmit() {
                this.getDataMixin();
            },
            onTimeChange(timeArray) {
                let start = '';
                let end = '';
                if (timeArray) {
                    start = moment(timeArray[0]).format('YYYY-MM-DD HH:mm:ss');
                    end = moment(timeArray[1]).format('YYYY-MM-DD HH:mm:ss');
                }
                this.tableOptions.params.createTimeStart = start;
                this.tableOptions.params.createTimeEnd = end;
                this.getDataMixin();
            },
            onSearchChange() {
                this.getDataMixin().finally(() => {
                    this.searchTip = this.tableOptions.params.name;
                });
            },
            onKeyup () {
                if (this.tableOptions.params.name === '' && this.searchTip !== '') {
                    this.onSearchChange();
                }
            },
            onOpenForm(){
                this.edit = true;
                this.currentRow = {};
                this.formVisible = true;
            },
            onFormSubmit(){
                this.getData();
            },
            onWithdraw({id}){
                newsService.withdrawNews(id).then(() => {
                    this.$message.success('下架成功');
                    this.getData();
                });
            },
            onLaunchNews({id}){
                newsService.launchNews(id).then(() => {
                    this.$message.success('上架成功');
                    this.getData();
                })
            },
            onEdit(row){
                this.currentRow = JSON.parse(JSON.stringify(row));
                this.edit = true;
                this.formVisible = true;
            },
            onView(row){
                this.onEdit(row);
                this.edit = false;
            },
            onDel(row){
                this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    newsService.delNews(row.id).then(() => {
                        this.$message.success('删除成功');
                        this.getData();
                    });
                }).catch(() => {
                });
            }
        }
    }
</script>
<style lang="scss">
    @import "./news-table";
</style>